import { useCallback, useMemo, useState } from 'react';
import { deleteCurrentAccount } from '../api/accountApi.js';

const EMPTY_NOTICE = { type: '', message: '' };
const CONFIRMATION_TEXT = '계정 삭제';

export function useAccountDeletion() {
  const [open, setOpen] = useState(false);
  const [confirmationText, setConfirmationText] = useState('');
  const [acknowledged, setAcknowledged] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [notice, setNotice] = useState(EMPTY_NOTICE);

  const canDelete = useMemo(
    () => Boolean(acknowledged && confirmationText.trim() === CONFIRMATION_TEXT),
    [acknowledged, confirmationText],
  );

  const openDialog = useCallback(() => {
    setConfirmationText('');
    setAcknowledged(false);
    setNotice(EMPTY_NOTICE);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    if (submitting) return;
    setOpen(false);
  }, [submitting]);

  const submit = useCallback(async (event) => {
    event.preventDefault();
    if (!canDelete) {
      setNotice({ type: 'error', message: `“${CONFIRMATION_TEXT}”를 정확히 입력하고 삭제 동의에 체크해주세요.` });
      return;
    }

    setSubmitting(true);
    setNotice(EMPTY_NOTICE);
    try {
      await deleteCurrentAccount({ confirmationText });
      setNotice({ type: 'success', message: '계정이 삭제되었습니다.' });
    } catch (error) {
      setNotice({ type: 'error', message: error?.message || '계정 삭제 중 오류가 발생했습니다.' });
      setSubmitting(false);
    }
  }, [canDelete, confirmationText]);

  return {
    open,
    confirmationText,
    acknowledged,
    submitting,
    notice,
    canDelete,
    setConfirmationText,
    setAcknowledged,
    openDialog,
    closeDialog,
    submit,
  };
}
